import React from 'react';

// Libraries
import classNames from 'classnames';

// Utils
import { FormattedMessage } from '@/utils/i18n';
import { HoldingAllocationMode } from '@/enums/Portfolio';
import { RISK_ALLOCATION_KEYS } from '@/utils/comparison';

interface HoldingsEditorHeaderProps {
  allocationMode: HoldingAllocationMode;
  className?: string;
  readOnly?: boolean;
  showDollars?: boolean;
  splitCashAndFixedIncome?: boolean;
}

const HoldingsEditorHeader: React.FC<HoldingsEditorHeaderProps> = ({ allocationMode, className, readOnly, showDollars, splitCashAndFixedIncome }) => {
  const classes = classNames('holdings-header', className);

  return (
    <div className={classes}>
      <div className="column holding" />

      {splitCashAndFixedIncome ? (
        <>
          <div className="column cash">
            <FormattedMessage id={`RiskProfile.${RISK_ALLOCATION_KEYS.CASH}`} />
          </div>

          <div className="column fixed-income">
            <FormattedMessage id={`RiskProfile.${RISK_ALLOCATION_KEYS.FIXED_INCOME}`} />
          </div>
        </>
      ) : (
        <div className="column cash-fixed-income">
          <FormattedMessage id="RiskProfile.CASH_FIXED_INCOME" />
        </div>
      )}

      <div className="column equity">
        <FormattedMessage id={`RiskProfile.${RISK_ALLOCATION_KEYS.EQUITY}`} />
      </div>

      <div className="column other">
        <FormattedMessage id={`RiskProfile.${RISK_ALLOCATION_KEYS.OTHER}`} />
      </div>

      <div className="column weight">
        {allocationMode === HoldingAllocationMode.Weight && <FormattedMessage id="HoldingsEditor.Weight" />}

        {allocationMode === HoldingAllocationMode.Units && <FormattedMessage id="HoldingsEditor.Units" />}
      </div>

      {showDollars && (
        <div className="column dollars">
          <FormattedMessage id="HoldingsEditor.Dollars" />
        </div>
      )}

      {!readOnly && <div className="column delete" />}
    </div>
  );
};

export default HoldingsEditorHeader;
